import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/(dynamic)/blog/category/[industry]/BlogPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
